module.exports = __webpack_public_path__ + "img/icon-long-1-2.e36f3d7a.png";